// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"cf55f0af","283":"cf55f0af","335":"cf55f0af","636":"cf55f0af","658":"cf55f0af","661":"cf55f0af","750":"cf55f0af","852":"cf55f0af","985":"cf55f0af"}[chunkId] + ".chunk.css";
};